import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { NotificationListSend } from "../model/notification-list.model";


@Injectable({
  providedIn: 'root'
})
export class NotificationListClientService {

  private readonly BASE_URL = environment.backendUrl + '/api/v1/notification-list';

  constructor(private http: HttpClient) {}


  getNotificationListUsersMinimal(): Observable<Array<NotificationListSend>> {
    return this.http.get<Array<NotificationListSend>>(`${this.BASE_URL}/list/minimal`, );
  }

  getNotificationListUsersAll(): Observable<Array<NotificationListSend>> {
    return this.http.get<Array<NotificationListSend>>(`${this.BASE_URL}/list/all`, );
  }

  deleteNotification(uuid: string): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${uuid}`);
  }

  muteNotificationType(type: string): Observable<void> {
      return this.http.post<void>(`${this.BASE_URL}/mute/${type}`, {});
    }

}
